import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./LoginPage.css";




export default function CreateTripDetailsPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const site = location.state?.site || {};

  const [tripName, setTripName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [inviteEmail, setInviteEmail] = useState("");
  const [invitees, setInvitees] = useState([]);
  const [crew, setCrew] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [selectedCrewIds, setSelectedCrewIds] = useState([]);
  const [selectedVehicleIds, setSelectedVehicleIds] = useState([]);

  useEffect(() => {
    const loadOwnerOptions = async () => {
      try {
        const res = await fetch("/api/profile/attendance-options", {
          credentials: "include",
        });
  
        const text = await res.text();
        console.log("📦 Status:", res.status);
        console.log("📦 Raw text:", text);
  
        const data = JSON.parse(text); // may still fail here
        setCrew(data.crew || []);
        setVehicles(data.vehicles || []);
      } catch (err) {
        console.error("❌ Failed to load attendance options:", err);
      }
    };
    loadOwnerOptions();
  }, []);
  

  const inputStyle = {
    width: "100%",
    margin: "10px 0",
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    backgroundColor: "#fff",
    color: "#000",
    boxSizing: "border-box",
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email.toLowerCase());
  };

  const handleInviteKeyDown = async (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      const raw = inviteEmail.trim().replace(/,$/, "");
      if (!raw || !validateEmail(raw)) {
        setInviteEmail("");
        return;
      }

      const alreadyInvited = invitees.some((entry) => entry.email.toLowerCase() === raw.toLowerCase());
      if (alreadyInvited) {
        setInviteEmail("");
        return;
      }

      try {
        const res = await fetch(`/api/users/lookup?email=${encodeURIComponent(raw)}`);
        const data = await res.json();
        const newEntry = data.found
          ? { email: raw, username: data.username, existing: true }
          : { email: raw, existing: false };

        setInvitees([...invitees, newEntry]);
      } catch (err) {
        console.error("❌ Error checking user:", err);
        setInvitees([...invitees, { email: raw, existing: false }]);
      } finally {
        setInviteEmail("");
      }
    }
  };

  const removeInvite = (email) => {
    setInvitees(invitees.filter((entry) => entry.email !== email));
  };

  const handleSave = async () => {
    try {
      const res = await fetch("/api/trips", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          tripName,
          location_id: site.id || null,
          location_name: site.name,
          location_url: site.url || "",
          start_date: startDate,
          end_date: endDate,
          invitees: invitees.map((i) => i.email),
          owner_crew_member_ids: selectedCrewIds,
          owner_ride_ids: selectedVehicleIds,
        }),
        
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Failed to create trip");

      console.log("✅ Trip created:", data);
      navigate("/");
    } catch (err) {
      console.error("❌ Error saving trip:", err.message);
      alert("Failed to save trip. Please try again.");
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>Create Trip</h2>

        <div><strong>Location:</strong> {site.name || "Unknown"}</div>
        
        <input
          type="text"
          value={tripName}
          onChange={(e) => setTripName(e.target.value)}
          placeholder="Trip Name"
          style={inputStyle}
        />

        <label style={{ fontSize: "0.9em", color: "#555" }}>Start Date</label>
        <input
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          style={inputStyle}
        />

        <label style={{ fontSize: "0.9em", color: "#555" }}>End Date</label>
        <input
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          style={inputStyle}
        />

        <label style={{ fontSize: "0.9em", color: "#555", marginTop: "15px" }}>Invite Campers</label>
        <input
          type="text"
          value={inviteEmail}
          onChange={(e) => setInviteEmail(e.target.value)}
          onKeyDown={handleInviteKeyDown}
          placeholder="Type email and press enter"
          style={inputStyle}
        />

        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginBottom: "20px" }}>
          {invitees.map((entry, idx) => (
            <div
              key={idx}
              style={{
                backgroundColor: entry.existing ? "#c8f7c5" : "#444",
                color: "#fff",
                padding: "6px 10px",
                borderRadius: "20px",
                display: "flex",
                alignItems: "center",
                fontSize: "0.9em",
              }}
            >
              {entry.existing ? (
                <img
                  src="/small-half-camper.png"
                  alt="User"
                  style={{ width: "20px", marginRight: "6px" }}
                />
              ) : (
                <span style={{ marginRight: "6px" }}>📧</span>
              )}
              {entry.existing ? entry.username : entry.email}
              <button
                onClick={() => removeInvite(entry.email)}
                style={{
                  marginLeft: "8px",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "bold",
                  color: "#fff",
                }}
              >
                ✖
              </button>
            </div>
          ))}
        </div>
      
          {/* Crew selection */}
          <div style={{ marginBottom: "10px" }}>
            <strong>Select Crew</strong>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "10px" }}>
              {crew.map((c) => {
                const selected = selectedCrewIds.includes(c.id);

                let imgSrc = "";
                if (c.type === "camper") {
                  imgSrc =
                    c.age === "baby" ? "/baby-image.png" :
                    c.age === "toddler" ? "/toddler-image.png" :
                    c.age === "child" ? "/child-image.png" :
                    "/camper-image.png";
                } else if (c.type === "pet") {
                  imgSrc =
                    c.pet_type === "Dog" ? "/pet-image.png" :
                    c.pet_type === "Horse" ? "/horse-image.png" :
                    c.pet_type === "Cat" ? "/cat-image.png" :
                    c.pet_type === "Velociraptor" ? "/velociraptor-image.png" :
                    "/dog-image.png";
                }

                return (
                  <div
                    key={c.id}
                    onClick={() =>
                      setSelectedCrewIds((prev) =>
                        selected ? prev.filter((i) => i !== c.id) : [...prev, c.id]
                      )
                    }
                    style={{
                      cursor: "pointer",
                      padding: "10px 14px",
                      borderRadius: "20px",
                      border: selected ? "2px solid #2ecc71" : "1px solid #ccc",
                      backgroundColor: selected ? "#c8f7c5" : "#f4f4f4",
                      color: "#333",
                      display: "flex",
                      alignItems: "center",
                      fontSize: "0.9em",
                    }}
                  >
                    <img
                      src={imgSrc}
                      alt={c.type}
                      style={{ width: "24px", height: "24px", marginRight: "8px" }}
                    />
                    {c.name}
                  </div>
                );
              })}
            </div>
          </div>


          {/* Vehicle selection */}
          <div style={{ marginBottom: "20px" }}>
            <strong>Select Vehicles</strong>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "10px" }}>
              {vehicles.map((v) => {
                console.log("🚗 Rendering vehicle:", v); //
                const selected = selectedVehicleIds.includes(v.id);

                let imgSrc = null;
                if (v.type === "car") {
                  switch (v.drivetrain?.trim().toLowerCase()) {
                    case "2 wheel drive":
                      imgSrc = "/2wd-image.png";
                      break;
                    case "all wheel drive":
                      imgSrc = "/awd-image.png";
                      break;
                    case "4 wheel drive":
                      imgSrc = "/4wd-image.png";
                      break;
                  }
                } else if (v.type === "trailer") {
                  switch (v.trailer_type) {
                    case "Camper Trailer":
                      imgSrc = "/camp-trailer-image.png";
                      break;
                    case "Caravan":
                      imgSrc = "/caravan-image.png";
                      break;
                    case "Other":
                    default:
                      imgSrc = "/trailer-image.png";
                      break;
                  }
                } else if (v.type === "boat") {
                  switch (v.boat_type?.trim().toLowerCase()) {
                    case "powerboat": imgSrc = "/powerboat-image.png"; break;
                    case "sailboat": imgSrc = "/sailboat-image.png"; break;
                    case "paddleboat": imgSrc = "/paddleboat-image.png"; break;
                    case "other": 
                    default: imgSrc = "/watercraft-image.png"; break;
                  }
                }

                // Use fallback text if make/model is blank
                const vehicleLabel = v.make || v.model
                  ? `${v.make || ""} ${v.model || ""}`.trim()
                  : v.boat_type || v.trailer_type || v.type;

                return (
                  <div
                    key={v.id}
                    onClick={() =>
                      setSelectedVehicleIds((prev) =>
                        selected ? prev.filter((i) => i !== v.id) : [...prev, v.id]
                      )
                    }
                    style={{
                      cursor: "pointer",
                      padding: "10px 14px",
                      borderRadius: "20px",
                      border: selected ? "2px solid #2ecc71" : "1px solid #ccc",
                      backgroundColor: selected ? "#c8f7c5" : "#f4f4f4",
                      color: "#333",
                      display: "flex",
                      alignItems: "center",
                      fontSize: "0.9em",
                    }}
                  >
                    {imgSrc && (
                      <img
                        src={imgSrc}
                        alt={vehicleLabel}
                        style={{ width: "24px", height: "24px", marginRight: "8px", objectFit: "contain" }}
                      />
                    )}
                    {vehicleLabel}
                  </div>
                );
              })}
            </div>
          </div>



        <button
          className="green-button"
          onClick={handleSave}
          style={{ width: "100%", marginBottom: "10px" }}
        >
          Save Trip
        </button>

        <button
          className="home-button"
          onClick={() => navigate("/")}
          style={{ width: "100%" }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
